/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum BaseGridSignatureEnum {
    TABLE_SIGNATURE_STANDARD = 1,
    TABLE_SIGNATURE_STANDARD_WITH_INTERNAL_MODIFICATIONS = 2,
    TABLE_SIGNATURE_COMPACT = 3,
    TABLE_SIGNATURE_MULTI = 4,
    TABLE_SIGNATURE_MASTER_DETAIL = 5,
}
